import React, { useState, useEffect, useRef } from 'react';
import { Table, Tag } from 'antd';
import { TablePaginationConfig } from 'antd/lib/table';
import type { TableProps } from 'antd';
import _ from 'lodash';

import SPTableActionBar from '../table-action-bar';

import { useOrderList } from 'hooks/order-management/order-list';
import {DEFAULT_PAGE_INFO} from "../../../../consts";
import { decryptTextByAES } from '../../../../utils/encryption';
import SPFigureHidden from 'components/base/SPFigureHidden';
import emiter, {_EVENTS} from "../../../../events";

interface IComponentProps {
  enums?: any;
  permission?: any;
}
interface IOrderListTableDataType {
    [index:string]: any;
};
const SPTable: React.FC<IComponentProps> = (props) => {
  const { enums, permission } = props;

  let columns: TableProps<IOrderListTableDataType>['columns'] = [
    { title: '订单编号', width: 200, render: (text, record) => <>
      <div>{record.order_code}</div>
      <div>{record.tags?.map((tag: any) => <Tag color='gold'>{tag}</Tag>)}</div>
    </>},
    { title: '订单状态', width: 90, key: 'order_status', render: (text, record) => _.find(enums.f_order_status, ['key', record.order_status]).value},
    { title: '订单金额', width: 100, render: (text, record) => `￥${record?.bill_info?.total_amount/100}`},
    { title: '退款金额', width: 100, render: (text, record) => `￥${record?.bill_info?.refund_amount/100}`},
    { title: '取消扣费', width: 100, render: (text, record) => `￥${record?.bill_info?.deduct_amount/100}`},
    { title: '驾驶人信息', width: 120, render: (text, record) => <SPFigureHidden content={record.driver_customer.name} type="name" /> },
    { title: '车辆信息', width: 200, render: (text, record) => <>
      <div>{record.veh_model_info.model_name}</div>
      <div>「{decryptTextByAES(record.veh_info.veh_plate) || '未排车'}」</div>
    </>},
    { title: '取车时间', width: 120, render: (text, record) => record.pickup_info.time || '-' },
    { title: '还车时间', width: 120, render: (text, record) => record.return_info.time || '-' },
    { title: '租期', width: 150, render: (text, record) => record.tenancy || '-' },
    { title: '取车方式/门店', width: 150, render: (text, record) => <>
      <div>【{_.find(enums.pickup_type, ['key', record.pickup_info.type])?.value}】</div>
      <div>{record.pickup_info.store_name}</div>
    </>},
    { title: '还车方式/门店', width: 150, render: (text, record) => <>
      <div>【{_.find(enums.return_type, ['key', record.return_info.type])?.value}】</div>
      <div>{record.return_info.store_name}</div>
    </>},
    { title: '取还车司机', width: 160, render: (text, record) => <>
      <div>取车：{record.pickup_driver_name || '「未排司机」'}</div>
      <div>还车：{record.return_driver_name || '「未排司机」'}</div>
    </>},
    { title: '下单时间', width: 120, key: 'create_time', dataIndex: 'create_time' },
    { title: '取消时间', width: 120, render: (text, record) => record.cancel_time || '-' },
    { title: '押金状态', width: 100, key: 'deposit_status', render: (text, record) => _.find(enums.f_deposit_status, ['key', record.deposit_status])?.value},
    { title: '操作', width: 100, key: 'action', fixed: 'right', render: (_, record) => (<SPTableActionBar permission={permission} data={record} />) },
  ];

  const [data, setData] = useState<any>([]);
  const [searchData, setSearchData] = useState<any>({});
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [currentPageData, setCurrentPageData] = useState<any>();
  const dataRef = useRef<any>({});

  const { search, tablePagination, onSearchAction } = useOrderList();

  const load = (params?: any) => {
    params = Object.assign({ ...DEFAULT_PAGE_INFO }, dataRef.current, params);
    setLoading(true)
    search(params).then((data: any) => {
      const res = data?.data
      setData(res?.list || []);
      setTotalCount(res?.total);
      dataRef.current = params
      setLoading(false)
      setCurrentPageData({ page: params.page, page_size: params.page_size });
    })
  };

  // TODO: 清空再搜索，翻页有问题
  const onPagination = (pagination: TablePaginationConfig) => {
    tablePagination(Object.assign(dataRef.current, {
        page: pagination.current,
        page_size: pagination.pageSize
    }))
  };

  useEffect(() => {
    emiter.on(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, load);
    return () => {
      emiter.removeAllListeners(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH)
    }
  }, []);

  // 根据筛选条件的订单状态，过滤列表字段
  if (_.includes([1, 2, 3], dataRef.current.order_status)) {
    columns = _.filter(columns, item => !_.includes(['退款金额', '取消扣费', '取消时间'], item.title))
  }

  return <Table
    size='middle'
    scroll={{ x: '100%' }}
    columns={columns}
    dataSource={data}
    rowKey={cols => cols.id}
    loading={loading}
    pagination={{ total: totalCount, showSizeChanger: true, showQuickJumper: true, showTotal:total => `共 ${total} 条数据`, current: currentPageData?.page, pageSize: currentPageData?.page_size }}
    onChange={onPagination}
    // TODO 滑动时固定表头，因外层整体有个padding，待统一调整
    // sticky={true}
    // summary={() => (
    //   <Table.Summary fixed={'top'} />
    // )}
  />
};

export default SPTable;

